import type { ClientId } from './ClientId';
import type { SerializableValue } from './ExtendedJSON';
import { getScenarioImprovements } from './suggestions/getScenarioImprovements';
import { getVoyageSuggestions } from './suggestions/getVoyageSuggestions';

// To add a new function capability to the worker, add it to this object and create a remoteFunction for it in the PlanningAssistantWorkerMaster.ts file

export const exposedWorkerFunctions = {
  getVoyageSuggestions,
  getScenarioImprovements,
};
type ExposedFunctionName = keyof typeof exposedWorkerFunctions;
type ExposedFunctionCall<FnName extends ExposedFunctionName> = {
  type: 'call';
  action: FnName;
  params: Parameters<(typeof exposedWorkerFunctions)[FnName]>;
};

export type ExposedFunctionResponse<FnName extends ExposedFunctionName> = {
  type: 'result';
  action: FnName;
  result: Awaited<ReturnType<(typeof exposedWorkerFunctions)[FnName]>>;
};

/** Just a helper for typing */
export type PlanningAssistantWorkerMessageCollection = {
  [FnName in ExposedFunctionName]: ExposedFunctionCall<FnName>;
};

export type PlanningAssistantWorkerMessage =
  PlanningAssistantWorkerMessageCollection[ExposedFunctionName];

export type PlanningAssistantCallbackResult = {
  type: 'fn_callback_result';
  callId: ClientId;
  result: SerializableValue;
};

/** Just a helper for typing */
type PlanningAssistantWorkerReturnValueResponse = {
  [FnName in ExposedFunctionName]: ExposedFunctionResponse<FnName>;
}[ExposedFunctionName];

export type PlanningAssistantWorkerResponse =
  | PlanningAssistantWorkerReturnValueResponse
  | {
      type: 'fn_callback';
      fnId: ClientId;
      callId: ClientId;
      parameters: SerializableValue[];
    }
  | {
      type: 'error';
      message: string;
    };
